import MicroModal from 'micromodal'
import React from 'react'
import { useState, useEffect } from "react";

/**
 * Componente de modal para mostrar la comunidad del club.
 *
 * @component
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.id - ID del modal.
 * @param {Object} props.object - Objeto que contiene la información de la comunidad.
 * @param {string} props.texto - Texto de la comunidad.
 * @returns {JSX.Element} Elemento JSX que representa el componente.
 */
const ModalComunidadClub = (props) => {

    const {id, object, texto} = props
    const [nombre, setNombre] = useState();
    const [descripcion, setDescripcion] = useState();
    const [traduccion, setTraduccion] = useState();
    const [clase, setClase] = useState();

    useEffect(() => {
        if(object != undefined){
            setNombre(object.nombre)
            setClase(`comunidad-act ${object.clase}`)
            setTraduccion(object.traduccion)
            setDescripcion(object.descripcion)
        }
    })

    const cerrarModal = () => {
        MicroModal.close('modal-club-comunidad', {
            awaitCloseAnimation: true
        });
    }

  return (
 <>
            <div className="micromodal-slide" id='modal-club-comunidad' aria-hidden="true">
                <div className="modal__overlay" data-micromodal-close>
                    <div className="modal__container_comunidad"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="titulo-visor-modal"
                    >
                    <div className='d-flex justify-content-end'>
                        <button className='min-botton d-flex justify-content-center align-items-center' onClick={() => { cerrarModal()}}>
                            <i className='icono-minus fas fa-times fa-2x fa-fw' />
                        </button>
                    </div>
                    <div className={`red--bg my-3 mx-auto ${clase}`}></div>
                    <p className='text-center titulo-comunidad py-3'><img src="/img/club-makemake/icon-2.png" className="img-fluid px-2 " />{nombre}</p>
                    <p className='comunidad-descripcion text-center pb-3'>{texto?.[traduccion] || descripcion}</p>
                    </div>
                </div>
            </div>
        </>
  )
}

export default ModalComunidadClub
